import { inject, Injectable } from '@angular/core';
import { interval, switchMap } from 'rxjs';
import { BasePollingService } from '../../../core/services/base-polling.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';
import { TransactionsViewComponent } from '../../components/transactions-view/transactions-view.component';
import { TransactionData } from '../../interfaces/transaction/transaction-data';
import { TransactionDataService } from '../transaction-data.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionsPollingService extends BasePollingService {

  dataService = inject(TransactionDataService);
  pollingInterval: number = inject(RuntimeConfigService).transactionDataPollingInterval;

  constructor() {
    super();
  }

  subscribePolling(component: TransactionsViewComponent) {
    this.pollingSubscription = interval(this.pollingInterval)
    .pipe(switchMap(() => this.dataService.findPage(component.lastLazyLoadingEvent, component.currentState)))
    .subscribe({
      next: (response) => {
        if (response.successful) {
          const newTransactionData: TransactionData[] = response.payload;
          /** Check if data has changed */
          if (this.helper.dataArrayHash(newTransactionData) !== component.lastDataHash) {
            component.tableComponent.getTablePageData(component.lastLazyLoadingEvent);
          }
        }
      },
      error: (err) => {
        console.error('Error on Transaction-Polling:', err);
      },
    });
    this.isSubscribed = true;
  }
}
